import React, { useState } from 'react';
import { useSubscription } from '../../../../../context/SubscriptionContext';

export function SwitchToTeam({ workspaceId }) {
  const { startCheckout } = useSubscription();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleSwitch = async () => {
    setBusy(true);
    setError('');
    try {
      await startCheckout('team', workspaceId);
    } catch {
      setError('Could not start Team. Try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="settings-modal__section">
      <h3 className="settings-people__title">Invite people</h3>
      <p className="settings-people__meta">
        Solo is just you. Team is $40 for you, then $40 for each person you add.
      </p>
      <div className="settings-people__actions">
        <button
          type="button"
          className="settings-modal__action-btn settings-modal__action-btn--primary"
          onClick={handleSwitch}
          disabled={busy}
        >
          {busy ? 'Switching…' : 'Switch to Team'}
        </button>
      </div>
      {error && <p className="settings-people__error">{error}</p>}
    </section>
  );
}
